export default {
    lang: {
        name: 'Language independence'
    }
}